// extracted by mini-css-extract-plugin
export default {"OrderSummary":"pPhILJDQfA","RDP":"_NN7b5xBY0","Price":"PHtxjNLopx","NoIcon":"hBGps38_vp","Breakdown":"NQIgn6fV7a","Indent":"QA_x8XAkls","Ctas":"OLGa5RUE4r"};